<template>
  <svg v-if="isFill" xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" :opacity="opacity" :style="{ color: color }" viewBox="0 0 36 36" fill="none">
    <g fill="#0F146D">
      <path :d="bagPath" />
      <path :d="handlePath" />
    </g>
    <path :d="heartPath" fill="#F57224" />
  </svg>
  <svg v-else xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" :opacity="opacity" :style="{ color: color }" viewBox="0 0 36 36" fill="none">
    <path :d="bagPath" :stroke="color" stroke-width="2" stroke-linejoin="round" />
    <path :d="handlePath" :stroke="color" stroke-width="2" stroke-linejoin="round" />
    <path :d="heartPath" :stroke="color" stroke-width="2" stroke-linejoin="round" />
  </svg>
</template>

<script>
// Original simplified shopping-bag + heart glyph (not the official trademark) — replace with the official logo after brand-guideline review.
const CONST_BAG_PATH = 'M7 12h22l1.5 18a2 2 0 0 1-2 2h-21a2 2 0 0 1-2-2z';
const CONST_HANDLE_PATH = 'M12 13v-3a6 6 0 0 1 12 0v3h-2.5v-3a3.5 3.5 0 0 0-7 0v3z';
const CONST_HEART_PATH = 'M18 26.5l-4.6-4.6a2.7 2.7 0 0 1 4.6-2.5a2.7 2.7 0 0 1 4.6 2.5z';

export default {
  name: 'LazadaIcon',
  props: {
    size: {
      type: [String, Number],
      default: 24,
    },
    color: {
      type: String,
      default: 'currentColor',
    },
    opacity: {
      type: [String, Number],
      default: 1,
    },
    isFill: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    bagPath() {
      return CONST_BAG_PATH;
    },
    handlePath() {
      return CONST_HANDLE_PATH;
    },
    heartPath() {
      return CONST_HEART_PATH;
    },
  },
};
</script>
